export default __webpack_public_path__ + "static/test-c9c5db76a01805afb20886ec0c19936e.png";